/**
 * SettingsInvitationStepFinal
 *
 * @package    Layouts
 * @author     Roman Kritskiy <rkritskiy@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

export default class SettingsInvitationStepFinal extends Component {
    /**
     * @type {Object}
     */
    static propTypes = {
        invitations: PropTypes.object,
        journalsData: PropTypes.array,
    };

    /**
     * Render
     *
     * @returns {*}
     */
    render() {
        const { invitations, journalsData } = this.props;
        if (!journalsData || !journalsData.length) return null;

        return (
            <div>
                <div className='invitations-summary-wrapper'>
                    <FormattedMessage id="invitations.summary" values={{journal: journalsData.find(journal => journal.id === invitations.journal_id).title}} />
                </div>
                <ul>
                    {invitations.invitations.map((user, key) => <li key={key}>{user.first_name + ' ' + user.last_name} <i>{'(' + user.email + ')'}</i></li>)}
                </ul>
                <div className='invitations-summary-confirm-wrapper'><FormattedMessage id="invitations.confirm" /></div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layouts/Settings/components/SettingsInvitation/SettingsInvitationStepFinal.jsx